import React, { useEffect, useRef, useState } from "react";
import axios from "axios";
import { useNavigate, useLocation, Link } from "react-router-dom";
import { Loader2, AlertCircle } from "lucide-react";

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
const API = `${BACKEND_URL}/api`;

// REMINDER: DO NOT HARDCODE THE URL, OR ADD ANY FALLBACKS OR REDIRECT URLS, THIS BREAKS THE AUTH

export default function AuthCallback() {
    const navigate = useNavigate();
    const location = useLocation();
    const hasProcessed = useRef(false);
    const [error, setError] = useState(null);

    useEffect(() => {
        if (hasProcessed.current) return;
        hasProcessed.current = true;

        const hash = location.hash || window.location.hash || "";
        const match = hash.match(/session_id=([^&]+)/);
        if (!match) {
            setError("No se encontró el código de sesión.");
            return;
        }
        const sessionId = decodeURIComponent(match[1]);

        const exchange = async () => {
            try {
                const res = await axios.post(
                    `${API}/auth/session`,
                    null,
                    {
                        headers: { "X-Session-ID": sessionId },
                        withCredentials: true,
                    }
                );
                // Clean URL and go to admin with user state
                window.history.replaceState(null, "", "/admin");
                navigate("/admin", {
                    replace: true,
                    state: { user: res.data },
                });
            } catch (err) {
                const detail = err?.response?.data?.detail;
                setError(
                    typeof detail === "string"
                        ? detail
                        : "No se pudo iniciar sesión. Intenta nuevamente."
                );
            }
        };
        exchange();
    }, [location, navigate]);

    return (
        <div className="min-h-screen flex items-center justify-center px-5">
            <div className="text-center max-w-md">
                {error ? (
                    <div data-testid="auth-callback-error">
                        <div className="w-14 h-14 rounded-full bg-destructive/10 flex items-center justify-center mx-auto mb-4">
                            <AlertCircle className="h-7 w-7 text-destructive" />
                        </div>
                        <h2 className="font-heading text-2xl font-medium mb-2">
                            No se pudo iniciar sesión
                        </h2>
                        <p className="text-muted-foreground mb-6">{error}</p>
                        <Link
                            to="/login"
                            className="inline-flex items-center gap-2 rounded-2xl px-5 py-2.5 bg-primary text-primary-foreground hover:-translate-y-0.5 transition-all"
                        >
                            Volver a intentar
                        </Link>
                    </div>
                ) : (
                    <div data-testid="auth-callback-loading">
                        <Loader2 className="h-7 w-7 animate-spin mx-auto text-primary mb-3" />
                        <p className="font-heading text-lg">Iniciando sesión...</p>
                        <p className="text-muted-foreground text-sm mt-1">
                            Estamos verificando tu cuenta.
                        </p>
                    </div>
                )}
            </div>
        </div>
    );
}
